/* ═══════════════════════════════════════════
   MUEL PARFUMS — Homepage Scripts
   For Shopify Ella Theme Integration
   ═══════════════════════════════════════════ */

(function() {
  'use strict';

  // Intersection Observer for scroll reveal animations
  var muelObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -40px 0px'
  });

  // Initialize on DOM ready
  function initMuel() {
    document.querySelectorAll('.muel-reveal').forEach(function(el) {
      muelObserver.observe(el);
    });
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMuel);
  } else {
    initMuel();
  }

  // Also re-initialize when Shopify Theme Editor loads sections
  document.addEventListener('shopify:section:load', function() {
    initMuel();
  });
})();
